export const CancelOperationMessage = 'Operation canceled due to new request.';
